<template>
    <flex-element :element-type="elementType" class="f-relative">
        <drop-zone-single
            v-for="(element, index) in elementsNew"
            :key="element.id"
            ref="layers"
            v-bind="element"
            :style="layerStyle"
            :index="index"
            :pointer="index + 1"
            @element-updated="elementUpdated"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';
import listenOnRootMixin from '@/mixins/listen-on-root';

const LAYER_INDEX_ATTR = 'layer-default-index';
const LAYER_TRANSITION_ATTR = 'layer-transition-speed';

export default {
    name: 'o-layered-container',
    mixins: [baseOrganism, listenOnRootMixin],

    data() {
        return {
            visibleLayerIndex: -1,
        };
    },

    computed: {
        // n.b. this is applied to ALL layers, regardless of whether they are visible or not
        // visibility-based inline styles are set in toggleLayerStyles()
        layerStyle() {
            return {
                transition: `opacity ${ this.speed }s !important`,
            };
        },

        speed() {
            return this.getElementData(LAYER_TRANSITION_ATTR) || '0.3'; // should match the default set in layer-transition.vue
        },
    },

    watch: {
        visibleLayerIndex() {
            this.toggleLayerStyles();
        },
    },

    created() {
        this.listenOnRoot('flex::layered-container::switch', this.onSwitchEvent);
    },

    mounted() {
        this.visibleLayerIndex = this.getElementData(LAYER_INDEX_ATTR);
    },

    methods: {
        onPrevious() {
            this.visibleLayerIndex = this.visibleLayerIndex <= 0 ? 0 : this.visibleLayerIndex - 1;
        },

        onNext() {
            const lastIndex = this.elements.length - 1;

            this.visibleLayerIndex = this.visibleLayerIndex >= lastIndex ? lastIndex : this.visibleLayerIndex + 1;
        },

        onSwitchEvent(eventData) {
            if (this.id === eventData.targetId) {
                this.visibleLayerIndex = eventData.layerNum - 1;
            }
        },

        // we need inline styles with !important (instead of CSS classes) to help ensure styles are not overridden
        // ... and also because we need to manage the transition speed
        toggleLayerStyles() {
            if (!this.$refs.layers) return;

            this.$refs.layers.forEach((layer, layerIndex) => {
                const isVisible = layerIndex === this.visibleLayerIndex;

                if (isVisible) {
                    this.removeHiddenStyles(layer.$el);
                } else {
                    this.addHiddenStyles(layer.$el);

                    // we want to scroll the hidden layers back up to the top, for a better UX in case they are displayed again
                    // the timeout ensures that the scrolling happens when the layer is no longer visible
                    const timeoutDelay = (this.speed * 1000) + 500;

                    window.setTimeout(() => {
                        this.scrollUp(layer.$el);
                    }, timeoutDelay);
                }
            });
        },

        addHiddenStyles(layerElem) {
            layerElem.style.setProperty('position', 'absolute', 'important');
            layerElem.style.setProperty('top', 0, 'important');
            layerElem.style.setProperty('z-index', -1, 'important');
            layerElem.style.setProperty('opacity', 0, 'important');
        },

        removeHiddenStyles(layerElem) {
            layerElem.style.setProperty('z-index', 1, 'important');
            layerElem.style.removeProperty('position');
            layerElem.style.removeProperty('top');
            layerElem.style.removeProperty('opacity');
        },

        scrollUp(layerElem) {
            layerElem.scrollTo(0, 0);
        },
    },
};
</script>
